__turbopack_context__.v({
  "answer": "quick-answer-card-module-scss-module__-oeXcG__answer",
  "badge": "quick-answer-card-module-scss-module__-oeXcG__badge",
  "card": "quick-answer-card-module-scss-module__-oeXcG__card",
  "copy": "quick-answer-card-module-scss-module__-oeXcG__copy",
  "question": "quick-answer-card-module-scss-module__-oeXcG__question",
});
